import {
  GET_APPOINTMENTS_LIST,
  GET_APPOINTMENTS_LIST_FAILURE,
  GET_APPOINTMENTS_LIST_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getAppointmentsListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_APPOINTMENTS_LIST:
      return { ...state, loading: true };
    case GET_APPOINTMENTS_LIST_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_APPOINTMENTS_LIST_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getAppointmentsListReducer;
